<template>
	<div>
		<!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
			<el-form-item label="商品名称">
				<el-input size="medium" clearable v-model="enquiryForm.merch_name" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="商品状态">
				<el-select v-model="enquiryForm.merch_status" medium clearable placeholder="请选择商品状态">
					<el-option label="上架" value="Y"></el-option>
					<el-option label="下架" value="N"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否实物">
				<el-select v-model="enquiryForm.pay_type" medium clearable placeholder="请选择是否实物">
					<el-option label="实物" value="10"></el-option>
					<el-option label="非实物" value="20"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品类型">
				<el-select v-model="enquiryForm.pos_type" medium clearable placeholder="请选择商品类型">
					<el-option label="杉峰Pro" value="10"></el-option>
				</el-select>
			</el-form-item>


			<div style="margin-bottom: 10px">
					<el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
					<el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
					<el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
					<el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
					<el-button size="medium" type="success" style="font-size: 12px;" @click="commodityAdd(enquiryForm)">添加商品</el-button>
			</div>

		</el-form>

		<el-tabs type="border-card" @tab-click="handleClick">
			<el-tab-pane label="现金购买">
				<!--    表格部分-->
				<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
					v-loading="loading" border id="tableDataId" size="mini">
					<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="merch_name" label="商品名称">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="marketing_lable" label="营销标签">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="pos_num" label="终端台数">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="buy_type" label="购买类型">
						<template slot-scope="scope">
							<p>{{ scope.row.buy_type.text}}</p>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="merch_status" label="商品状态">
						<template slot-scope="scope">
							<el-button type="success" v-if="scope.row.merch_status.value == 'Y'" size="mini"
								@click="merchStatus(scope.row,'N')">{{ scope.row.merch_status.text}}</el-button>
							<el-button type="danger" v-if="scope.row.merch_status.value == 'N'" size="mini"
								@click="merchStatus(scope.row,'Y')">{{ scope.row.merch_status.text}}</el-button>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="compose" label="商品类型">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="price" label="金额/积分">
						<template slot-scope="scope">
							<p>￥{{ scope.row.price}}</p>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="stock" label="库存">
					</el-table-column>
					<el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="100">
						<template slot-scope="scope" style="text-align: center;">
							<el-button type="text" @click="info(scope.row)">编辑</el-button>
							<el-button type="text" @click="stockInfo(scope.row)" style="margin-left: 10px">库存</el-button>
							<el-button type="text" @click="deleteList(scope.row)" style="margin-left: 10px">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="积分兑换">
				<!--    表格部分-->
				<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
					v-loading="loading" border id="tableDataId" size="mini">
					<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="merch_name" label="商品名称">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="marketing_lable" label="营销标签">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="pos_num" label="终端台数">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="buy_type" label="购买类型">
						<template slot-scope="scope">
							<p>{{ scope.row.buy_type.text}}</p>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="merch_status" label="商品状态">
						<template slot-scope="scope">
							<el-button type="success" v-if="scope.row.merch_status.value == 'Y'" size="mini"
								@click="merchStatus(scope.row,'N')">{{ scope.row.merch_status.text}}</el-button>
							<el-button type="danger" v-if="scope.row.merch_status.value == 'N'" size="mini"
								@click="merchStatus(scope.row,'Y')">{{ scope.row.merch_status.text}}</el-button>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="compose" label="商品类型">
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="coin" label="金额/积分">
						<template slot-scope="scope">
							<p>{{ scope.row.coin}}积分</p>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" prop="stock" label="库存">
					</el-table-column>
					<el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="100">
						<template slot-scope="scope" style="text-align: center;">
							<el-button type="text" @click="info(scope.row)">编辑</el-button>
							<el-button type="text" @click="stockInfo(scope.row)" style="margin-left: 10px">库存</el-button>
							<el-button type="text" @click="deleteList(scope.row)" style="margin-left: 10px">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>

		</el-tabs>

		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>



		<el-dialog v-if="dialogVisible" title="修改库存" :visible.sync="dialogVisible" width="30%">
			<el-form :inline="true" :model="dialogForm" class="demo-form-inline">
				<el-form-item label="库存数量">
					<el-input size="medium" clearable v-model="dialogForm.stock" placeholder="请输入"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDialog">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</div>
		</el-dialog>
		<prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
	</div>
</template>

<script>
	import {
		export_json_to_excel
	} from "@/excel/Export2Excel";
	import prints from '@/components/print.vue';
	export default {
		name: "userInformationOne",
		components:{
			prints
		},
		data() {
			return {
				// 主页面部分
				loading: true, //列表loadding
				page_size: 20, //条数
				total: 0, //总数
				tableData: [], //表格数据
				enquiryForm: {
					page_size: 20,
					page: 1,
					merch_name: '',
					merch_status: '',
					pay_type: '',
					pos_type: '',
					buy_type: '10',
				},
				dialogVisible: false,
				dialogForm: {},
				//打印
				tableTh:null,
				tableTd:null,
			}
		},
		created() {
			this.getData(this.enquiryForm);
			this.tableTh = ['ID', '商品名称', '营销标签', '终端台数', '购买类型', '商品状态', '商品类型', '金额/积分','库存'];
			this.tableTd = ['id', 'merch_name', 'marketing_lable', 'pos_num', 'buy_type_text', 'merch_status_text',
					'compose', 'price_text', 'stock'];
			this.$nextTick(()=>{
				this.$refs.prints.prints();
			})
		},
		methods: {
			//上架下架
			merchStatus(row, can) {
				let text = can == "N" ? '即将下架该商品, 是否继续?' : '即将上架该商品, 是否继续?'
				let data = {
					id: row.id,
					merch_status: can
				}
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post("/api/goods/status", data, res => {
						if (res.status == 200) {
							this.$message.success(res.msg);
							this.getData(this.enquiryForm)
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//库存
			stockInfo(row) {
				this.dialogForm.id = row.id;
				this.dialogForm.stock = row.stock;
				this.dialogVisible = true;
			},
			submitForm() {
				this.$api.post("/api/goods/stock", this.dialogForm, res => {
					if (res.status == 200) {
						this.dialogVisible = false;
						this.dialogForm = {};
						this.$message.success(res.msg);
						this.getData(this.enquiryForm)
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			cancelDialog() {
				this.dialogVisible = false;
			},
			//添加商品
			commodityAdd() {
				this.$router.push({
					path: '/productDetails',
					query: {},
				})
			},
			//查看详情
			info(row) {
				this.$router.push({
					path: '/productDetails',
					query: {
						id: row.id
					},
				})
			},
			//删除
			deleteList(row) {
				let data = {
					id: row.id,
				}
				this.$confirm('即将删除该商品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post("/api/goods/delete", data, res => {
						if (res.status == 200) {
							this.$message.success(res.msg);
							this.getData(this.enquiryForm)
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//切换
			handleClick(tab, event) {
				if (tab.index == 0) {
					this.enquiryForm.buy_type = '10';
				} else {
					this.enquiryForm.buy_type = '20';
				}
				this.getData(this.enquiryForm);
			},

			//打印
			printEvent(){
				this.tableData.forEach(item => { //实名状态转换文本
					item.buy_type_text = item.buy_type.text;
					item.merch_status_text = item.merch_status.text;
					if (item.buy_type.value == '10') {
						item.price_text = '￥' + item.price;
					} else if (item.buy_type.value == '20') {
						item.price_text = item.coin + '积分'
					}
				});
				this.$nextTick(()=>{
					this.$refs.prints.prints();
					this.$refs.prints.print();
				})
			},
			// 主页面部分
			//搜索
			handleSearch(searchForm) {
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//重置
			Reset(searchForm) {
				searchForm.page = 1;
				searchForm.reward_status = "";
				searchForm.merch_name = '';
				searchForm.merch_status = '';
				searchForm.pay_type = '';
				searchForm.pos_type = '';
				this.getData(searchForm);
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.enquiryForm.page = page;
				this.getData(this.enquiryForm);
			},
			handleSizeChange(limit) { //条数
				this.enquiryForm.page_size = limit;
				this.enquiryForm.page = 1;
				this.getData(this.enquiryForm);
			},
			//获取数据
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/goods/manage?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						this.tableData = tableData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},

			// 导出
			exportData() {
				let th = ['ID', '商品名称', '营销标签', '终端台数', '购买类型', '商品状态', '商品类型', '金额/积分', '库存'];
				let excelData = ['id', 'merch_name', 'marketing_lable', 'pos_num', 'buy_type_text', 'merch_status_text',
					'compose', 'price_text', 'stock'
				];
				this.tableData.forEach(item => { //实名状态转换文本
					item.buy_type_text = item.buy_type.text;
					item.merch_status_text = item.merch_status.text;
					if (item.buy_type.value == '10') {
						item.price_text = '￥' + item.price;
					} else if (item.buy_type.value == '20') {
						item.price_text = item.coin + '积分'
					}
				});
				let data = this.formatJson(excelData, this.tableData);
				let defaultTitle = '导出文件';
				export_json_to_excel(th, data, defaultTitle)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},



		}
	}
</script>

<style scoped>
	/deep/ .el-form-item__content .el-input-group {
		vertical-align: middle !important;
	}

	.code {
		cursor: pointer;
	}

	.code:hover {
		color: blue;
		text-decoration: underline;
	}

	.transactionInfoBox {
		color: #606266;
		font-size: 14px;
		word-break: break-all;
	}

	.transactionInfoBoxTitle {
		font-style: normal;
		display: inline-block;
		width: 150px;
		text-align: right;
		font-weight: 700;
	}
</style>
